import { t } from "@/i18n-js/instance";
import { BlockListItem } from "../BlockListItem";

export const DescriptionItem = () => (
  <BlockListItem
    icon="16-document-text"
    label={t("courses.lockscreen.description")}
  />
);
